import React from 'react';
import { Link } from 'gatsby';

import * as MenuItems from 'views/components/menu-items';
import { Root, Layout, Logo, Company, Slogan, Menu } from './index.styled';
import logoImage from './assets/logo-image.gif';

const HEIGHT = '122px';

const Header = () => {
  return (
    <Root>
      <Layout height={HEIGHT}>
        <Logo>
          <Link to="/">
            <img src={logoImage} alt="精密プラスチック射出成形｜株式会社野中製作所" />
          </Link>
        </Logo>
        <Slogan>精密プラスチック射出成形</Slogan>
        <Company>株式会社野中製作所</Company>
        <Menu>
          <ul>
            <li>
              <MenuItems.MoldedPieceMenu />
            </li>
            <li>
              <MenuItems.EquipmentMenu />
            </li>
            <li>
              <MenuItems.CompanyMenu />
            </li>
            <li>
              <MenuItems.AccessMenu />
            </li>
            <li>
              <MenuItems.ContactMenu />
            </li>
          </ul>
        </Menu>
      </Layout>
    </Root>
  );
};

export default Header;
export { HEIGHT };